export default defineNuxtRouteMiddleware((to) => {
  if (!to.query.date) {
    const today = new Date().toISOString().slice(0, 10)

    return navigateTo({
      path: to.path,
      query: { ...to.query, date: today },
    }, { replace: true })
  }
})
